(function () {
    if (document.body.classList.contains('template_product') && document.querySelector('[name="Size"]:checked')) {
        const dataFrame = document.querySelector('[data-frame]')
        const sizeInputs = document.querySelectorAll('[name="Size"]')
        const frameInputs = document.querySelectorAll('[name="Frame"]')
        const mountInputs = document.querySelectorAll('[name="Mount"]')
        
        let size = document.querySelector('[name="Size"]:checked').value.toLowerCase()
        let frame = document.querySelector('[name="Frame"]:checked').value.toLowerCase()
        let mount = document.querySelector('[name="Mount"]:checked').value.toLowerCase()    

        sizeInputs.forEach(el => {
            el.addEventListener('change', () => {
                size = el.value.toLowerCase()
                setFrame()
            })
        })

        frameInputs.forEach(el => {
            el.addEventListener('change', () => {
                frame = el.value.toLowerCase()
                setFrame()
            })
        })

        mountInputs.forEach(el => {
            el.addEventListener('change', () => {
                mount = el.value.toLowerCase()
                setFrame()
            })
        })

        const setFrame = () => {
            if (size == 'vivid' || size == 'prestige') {
                dataFrame.dataset.frame = `${size} / no frame / full bleed`
                document.querySelector('.product__frames').classList.add('disabled')
                document.querySelector('[for="mount_border"]').classList.add('disabled')
                document.querySelector('[for="mount_full_bleed"]').click()
                document.querySelector('[for="frames_no_frame"]').click()
            } else {
                dataFrame.dataset.frame = `${size} / ${frame} / ${mount}`
                document.querySelector('.product__frames').classList.remove('disabled')
                document.querySelector('[for="mount_border"]').classList.remove('disabled')
                if (document.querySelector('#frames_no_frame:checked')) {
                    document.querySelector('[for="frames_black"]').click()                    
                }
            }

            console.log(mount)

            if(mount == 'full bleed') {
                document.querySelectorAll('.product__picture_size .border').forEach(el => {
                    el.classList.remove('active')
                })
                document.querySelectorAll('.product__picture_size .no_border').forEach(el => {
                    el.classList.add('active')
                })
            } else {
                document.querySelectorAll('.product__picture_size .no_border').forEach(el => {
                    el.classList.remove('active')
                })
                document.querySelectorAll('.product__picture_size .border').forEach(el => {
                    el.classList.add('active')
                })
            }
            
        }

        setFrame()
        
    }
})();

// product tabs
(function () {
    if (document.body.classList.contains('template_product')) {
        const tabButtons = document.querySelectorAll('.product_tabs__item')
        const tabContentItems = document.querySelectorAll('.product_tabs__content_item')

        tabButtons.forEach(el => {
            el.addEventListener('click', () => {
                tabButtons.forEach(element => {
                    element.classList.remove('active')
                })
                el.classList.add('active')
                tabContentItems.forEach(item => {
                    item.classList.remove('open')
                    item.style.maxHeight = 0; 
                })

                tabContentItems.forEach(item => {
                    if(el.dataset.value == item.dataset.value) {
                        item.classList.add('open')
                        item.style.maxHeight = item.scrollHeight + 'px'; 
                        console.log(item.scrollHeight)
                    }
                })
            })
        })

        
    }
})();
// product tabs

// product interior 
(function () {
    if (document.body.classList.contains('template_product')) {
        

        var swiper = new Swiper('.product_interior__gallery', {
            spaceBetween: 18,
            slidesPerView: 2,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              768: {
                slidesPerView: 3
              },
              1024: {
                slidesPerView: 4
              }
            }
        });
    }
})();
// product interior 

// member tooltip
(function () {
    if ( document.querySelector('.price_wr--member')) {
        const container = document.querySelector('.price_wr--member')
        const tooltip = container.querySelector('.tooltip')

        container.addEventListener('mouseenter', () => {
            tooltip.classList.add('active')
        })

        container.addEventListener('mouseleave', () => {
            tooltip.classList.remove('active')
        })
    }
})();
// member tooltip

// product accordion
(function () {
    const faqTitles = document.querySelectorAll('.product_tabs__item_title')
  
    faqTitles.forEach(element => {
      element.addEventListener('click', () => {
        const triggerFaq = () => {
          const hideAccordions = () => {
            faqTitles.forEach(element2 => {
              element2.parentElement.classList.remove('open')
              element2.nextElementSibling.classList.remove('open');
              element2.nextElementSibling.style.maxHeight = 0;
            })     
          }
          
  
          if (element.parentElement.classList.contains('open')) {
            if (!element.closest('.no-hide')) {
              hideAccordions()
            }   
            element.nextElementSibling.classList.remove('open');
            element.parentElement.classList.remove('open');
            element.nextElementSibling.style.maxHeight = 0;
          } else {
            if (!element.closest('.no-hide')) {
              hideAccordions()
            }
  
            element.parentElement.classList.add('open');
            element.nextElementSibling.classList.add('open');
            element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + 'px'; 
          }
        }
        triggerFaq()
        
      })
    });

    if (window.innerWidth < 768) {
        document.querySelectorAll('.product_tabs__content_item').forEach(el => {
            el.classList.remove('open')
        })
    }
  })();
// product accordion

// catalog menu
(function () {
    const menu = document.querySelector('.catalog_menu')
    const menu_links = document.querySelectorAll('.catalog_menu__list_links a')
    const close = menu.querySelector('.close')
    const catalogButton = document.querySelectorAll('.header__menu-item--catalog')

    catalogButton.forEach(el => {
        el.addEventListener('click', (e) => {
            console.log(el)
            e.preventDefault()
            menu.classList.add('active')
        })
    })
    
 
    close.addEventListener('click', () => {
        menu.classList.remove('active')
    })
    menu_links.forEach(el => {
        el.addEventListener('mouseenter', () => {
            menu_links.forEach(item => {
                item.classList.remove('active')
            })

            el.classList.add('active')

            document.querySelectorAll('.catalog_menu__images img').forEach(img => {
                img.classList.remove('active')
            })
            document.querySelector(`.catalog_menu__images img[data-menu='${el.dataset.menu}']`).classList.add('active')
        })
    })
})();
// catalog menu